import * as Sentry from '@sentry/react';
import { DELETE } from 'common/helpers.ts';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import useSWRMutation from 'swr/mutation';
import type { Shipment } from 'types/Shipment.ts';
import { DeleteDialog } from '#admin/component/DeleteDialog.tsx';
import { getTranslatedError } from '#admin/helpers.ts';

type Props = {
  shipment: Shipment;
  onSave?: () => void;
  onClose?: () => void;
  isOpen: boolean;
};

export const ShipmentDialog: React.FC<Props> = ({ shipment, onSave, onClose, isOpen }) => {
  const { t } = useTranslation();
  const deleteSwr = useSWRMutation([`/shipment/${shipment.id}`], DELETE);

  const onConfirm = async () => {
    try {
      await deleteSwr.trigger();
      if (onSave) onSave();
    } catch (error) {
      console.error(error);
      Sentry.captureException(error);
    }
  };

  return (
    <DeleteDialog
      key={shipment.id}
      isOpen={isOpen}
      onClose={onClose ?? (() => {})}
      onConfirm={onConfirm}
      title={t('dialogs.shipment.deleteTitle')}
      message={deleteSwr.error ? getTranslatedError(deleteSwr.error, t) || t('dialogs.shipment.unknownError') : t('dialogs.shipment.confirmMessage')}
      loading={deleteSwr.isMutating}
    />
  );
};
